import { useCallback, useEffect, useState } from 'react';
import PageDefault from 'components/PageDefault';
import companyService from 'services/company.service';
import { useHistory, useRouteMatch } from 'react-router';
import extractFormData from 'utils/extractFormatData';
import { Button } from 'react-bootstrap';
import CompanyData from './CompanyData';
import LoadPage from 'components/LoadPage';
import { useTranslation } from 'react-i18next';

export default function FormCompany(){
  let match = useRouteMatch<any>();
  const [ data, setData ] = useState<any>({});
  // const [ dataCompare, setDataCompare ] = useState<any>({});
  // const [ isShow, setIsShow ] = useState<boolean>(false);
  const history = useHistory();
  const [ loadPage, setLoadPage ] = useState(true);
  const [ errorPage, setErrorPage ] = useState(false);

  const { t } = useTranslation()

  const getData = useCallback((id:number)=>{
    companyService.show(id,{params:{
      // fields:"id,firstname,lastname,email,profile_id",
      embed:"periods:company_id,start_period,fiscal_year",
      // appends:"periods.total_amount"
    }}).then(data=>{
      formatData(data);
      setLoadPage(false);
      // setData(data);
      // setDataCompare(data);
    }).catch(error=>{
      console.log(error);
      
      setErrorPage(true);
    })
  },[]);

  useEffect(()=>{
    if(match.params && match.params.id){
      getData(match.params.id);
    } else {
      setLoadPage(false);
    }
    if(match.url.indexOf("show") !== -1){
      // setIsShow(true);
    }
  },[match, getData])

  function formatData(data:any){
    let data_aux:any = {};
    Object.keys(data).forEach((name:string)=>{
      if(data[name])
      data_aux[name] = data[name];
    })
    data_aux.start_period = "0000-00-00";
    data_aux.fiscal_year = "0000";


    // data_aux.fund_model = data.fund_model.id

    

    setData(data_aux);
  }

  function submit(){
    let formdata = new FormData();
    extractFormData(data,formdata);
    if(match.params && match.params.id){
      formdata.append('_method', 'put');
      companyService.updateLoad(match.params.id,formdata).then((data:any)=>{
        history.push(`/company`)
      })
    } else {
      companyService.storeLoad(formdata).then((data:any)=>{
        history.push(`/company`)
      })
    }
  }  

  if(loadPage) return (
    <LoadPage 
      textLoad="Obtendo dados da empresa"
      textError="Erro ao carregar dados da empresa"
      error={errorPage}
    />
  );

  return (
    <PageDefault title={t("title:company:form")}>
      <PageDefault.Title>{t("title:company:form")}</PageDefault.Title>
      <PageDefault.Content>
        <CompanyData data={data} setData={setData}/>
      </PageDefault.Content>
      <PageDefault.Footer>
        <Button size="sm"  onClick={submit}>Salvar</Button>
      </PageDefault.Footer>
    </PageDefault>
  );
}